import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export const mergeRecipientFromMime = (
    recipientFromMime: EmailAddressWrapper,
    originalRecipient?: EmailAddressWrapper
): EmailAddressWrapper => {
    if (!(originalRecipient && recipientFromMime)) {
        return recipientFromMime || originalRecipient;
    }

    return {
        ...originalRecipient,
        Name: recipientFromMime.Name || originalRecipient.Name,
        OriginalDisplayName:
            recipientFromMime.OriginalDisplayName || originalRecipient.OriginalDisplayName,
        EmailAddress: recipientFromMime.EmailAddress,
    };
};

const mergeRecipientsFromMime = (
    recipientsFromMime: EmailAddressWrapper[],
    originalRecipients?: EmailAddressWrapper[]
): EmailAddressWrapper[] => {
    if (!originalRecipients || !originalRecipients.length) {
        return recipientsFromMime;
    }

    const emailAddressToOriginalRecipientMap = originalRecipients.reduce(
        (emailAddressToRecipientMap, originalRecipient) => {
            if (originalRecipient?.EmailAddress) {
                emailAddressToRecipientMap[
                    originalRecipient.EmailAddress.toLowerCase()
                ] = originalRecipient;
            }
            return emailAddressToRecipientMap;
        },
        {}
    );

    return recipientsFromMime.map((recipientFromMime: EmailAddressWrapper) => {
        if (!recipientFromMime?.EmailAddress) {
            return recipientFromMime;
        }

        const originalRecipient: EmailAddressWrapper =
            emailAddressToOriginalRecipientMap[recipientFromMime.EmailAddress.toLowerCase()];

        return mergeRecipientFromMime(recipientFromMime, originalRecipient);
    });
};

export default mergeRecipientsFromMime;
